var map = {
	"./c_bg_color.vue": "95a6",
	"./c_cascader.vue": "b500",
	"./c_foot.vue": "312f",
	"./c_goods.vue": "a497",
	"./c_hot_box.vue": "6b1a",
	"./c_hot_imgs.vue": "27ef",
	"./c_hot_word.vue": "f3ffe",
	"./c_input_item.vue": "c31e",
	"./c_input_number.vue": "8055",
	"./c_is_show.vue": "3d85",
	"./c_menu_list.vue": "c774",
	"./c_page_ueditor.vue": "bd5a2",
	"./c_pictrue.vue": "60e2",
	"./c_product.vue": "fe40",
	"./c_select.vue": "5413",
	"./c_select_list.vue": "4875",
	"./c_set_up.vue": "fed0",
	"./c_slider.vue": "80c1",
	"./c_status.vue": "e291",
	"./c_tab.vue": "2756",
	"./c_txt_tab.vue": "58f1",
	"./c_upload_img.vue": "500d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c34";